import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("video4", component(opts));
  editor.BlockManager.add("video4", block(opts));
};